import { connect } from 'react-redux'
import { setCamperFormField, setCamperForm } from 'actions/account/campers'

const mapStateToProps = ({ campers: { form } }) => ({ form })

const actions = { setCamperFormField, setCamperForm }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
